<template>
    <div>
        <h2>直播议程列表</h2>
        <div class="search-date">
            <el-date-picker v-model="value" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" @change="getLiveList('0')"></el-date-picker>
        </div>
        <div class="list_wrap">
            <ul class="">
                <li v-for="(item, index) in listData" :key="index" @click="getLiveList(index)" :class="curIndex == index ? 'cur' : ''">
                    <span class="txt">{{ item.startTime | filtersDate }}~{{  item.endTime | filtersDate }}</span>
                    <span class="subject">{{ item.subject }}</span>
                    <!-- <span class="setlink fr" @click="setLink(item)">配置带货链接</span> -->
                </li>
            </ul>
            <div class="content">
                <div class="wrap">
                    <h2 class="title">配置带货链接</h2>
                    <div class="line">
                        <div class="box">
                            <el-button type="primary" size="mini" icon="el-icon-plus" @click="addSetLink">添加</el-button>
                            <ul class="clearfix" id="linkWrap">
                                <li class="linkipt clearfix" v-for="(item, index) in linkData" :key="index">
                                    <el-input disabled clearable size="mini" class="name fl" v-model="item.bookname"></el-input>
                                    <el-input disabled clearable size="mini" class="url fl" v-model="item.openuri"></el-input>
                                    <el-switch @change="switchChange(item)" size="mini" class="fl" v-model="item.openstate" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#eee"></el-switch>
                                    <el-button size="mini" type="primary" icon="el-icon-edit" @click="editorInfo(item)" plain></el-button>
                                    <el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteInfo(item)" plain></el-button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>        
        </div>
        <el-dialog title="配置带货链接" :before-close="handleClose" :visible.sync="dialogVisible" :destroy-on-close="true">
            <el-form :model="form" :rules="rules" ref="form" size="mini" label-width="120px" class="ruleForm">
                <el-form-item label="直播ID：" v-if="false">
                    <el-input v-model="form.webinarId"></el-input>
                </el-form-item>
                <el-form-item label="书名：" prop="bookname">
                    <el-input v-model="form.bookname" @focus="handleClick" placeholder="请选择书名..."></el-input>
                </el-form-item>
                <el-form-item label="书目封面：" v-if="form.bookurl">
                    <div class="fm"><img :src="form.bookurl" /></div>
                </el-form-item>
                <!-- <el-form-item label="链接名称：" prop="linkname">
                    <el-input v-model="form.linkname" placeholder="请输入链接名称..."></el-input>
                </el-form-item> -->
                <el-form-item label="链接地址：" prop="openuri">
                    <el-input v-model="form.openuri" placeholder="请输入链接地址..."></el-input>
                </el-form-item>
                <el-form-item label="链接开关：">
                    <el-switch size="mini" class="fl" v-model="form.openstate" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#eee"></el-switch>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveSetLink">保存</el-button>
                    <el-button @click="resetForm()">清空</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        
        <el-dialog width="1200px" title="选择书籍" :visible.sync="changeDialogVisible" :destroy-on-close="true">
            <!-- <component :is="dialogOption.view" @close="closeDialog"></component> -->
            <book-select ref="chooseBook" @close="closeDialog"></book-select>
        </el-dialog>
    </div>
</template>

<script>
import { DatePicker, Dialog, Input, Switch, Button, Loading } from 'element-ui'
import { activitylistSomeDay } from '@/api/VhallLive'
import { saveAddLivelink, updateLivelink, getLivelink, deleteLivelink } from '@/api/liveLink'
import BookSelect from '../../Components/BookSelect.vue'

export default {
    data(){
        return {
            // typeFlag: 0, //添加操作0,修改操作1
            updateId:'',
            webinarId: '',
            value: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
            listData:[],
            curData: {},
            val: '',
            flag: 0,
            linkData: [],
            curIndex: 0,
            dialogVisible: false,
            form: {
                webinarId:'',
                bookname:'',
                bookurl:'',
                // linkname: '',
                openuri:'',
                openstate: 0
            },
            rules:{
                // bookname: [{ required: true, message: '请输入选择书籍！', trigger: 'focus' }],
                openuri: [{ required: true, message: '请输入链接地址！', trigger: 'blur' }]
            },
            changeDialogVisible: false,
            showLoading: null,
        }
    },
    components:{ BookSelect, Loading, 'el-date-picker': DatePicker, 'el-dialog': Dialog, 'el-input': Input, 'el-switch': Switch, 'el-button': Button },
    filters:{        
        filtersDate(value) {
            if(value){
                var dateF = value.split(' ');
                return dateF[1];
            }
        }
    },
    mounted(){
        let vm = this;
        vm.getLiveList('0');
    },
    methods:{
        // 选择出版社
        handleClick(row) {
            let vm = this;
            vm.changeDialogVisible = true;
        },
        closeDialog(row){
            let vm = this;
            // 如果有值传进来，则做更新操作
            vm.changeDialogVisible = false;
            vm.form.bookname = row.title;
            vm.form.bookurl = row.imageUrl;
            if(row.goodsId) vm.form.openuri = window.location.origin + '/#/BookDetail/' + row.goodsId;
        },
        // 弹窗关闭
        handleClose(done){
            let vm = this;
            // vm.form.webinarId = '';
            // vm.form.linkname = '';
            vm.form.openuri = '';
            vm.form.openstate = 0;
            done();
        },
        //点击议程
        // setLinkRight(index){
        //     let vm = this;
        //     vm.curIndex = index;
        //     vm.getLiveList(vm.curIndex);
        // },
        //编辑修改
        editorInfo(data){
            let vm = this;
            vm.dialogVisible = true;
            // vm.typeFlag = 1; // 修改操作1
            vm.updateId = data.id;
            vm.form.webinarId = vm.webinarId;
            vm.form.bookname = data.bookname;
            vm.form.bookurl = data.bookurl;
            vm.form.openuri = data.openuri;
            vm.form.openstate = data.openstate;
        },
        //删除
        deleteInfo(data){
            let vm = this;
            vm.$confirm('确定删除该带货链接吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteLivelink({id: data.id}).then(res => {
                    if(res.data){
                        vm.$message({ type: 'success', message: '删除成功!' });
                        vm.getCurLinklist();//刷新链接列表
                    }else{
                        vm.$message({ type: 'error', message: '删除失败!' });
                    }
                }).catch(err => {
                    vm.$message({ type: 'error', message: err.msg || '删除失败!' });
                })
            }).catch(() => {
                vm.$message({ type: 'info', message: '已取消删除' });          
            });
        },
        //保存
        saveSetLink(){
            let vm = this; 
            // vm.linkData.push(newData);
            vm.$refs['form'].validate((valid) => {
                if (valid) {
                    let data = vm.form;          
                    vm.showLoading = Loading.service({
                        target: 'body',
                        spinner: 'el-icon-loading',
                        text: '加载中...',
                        background: 'rgba(255, 255, 255, 0.5)'
                    });
                    if(vm.updateId == ''){ //添加保存
                        saveAddLivelink(data).then(res => {
                            if(res.data){
                                vm.$message({ showClose: true, message: '添加成功！',type: 'success' });
                                vm.getCurLinklist();//刷新链接列表
                                vm.dialogVisible = false;   
                            }else{
                                vm.$message({ showClose: true, message: '添加失败！',type: 'error' });
                            }                            
                            vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                vm.showLoading.close();
                            });
                        }).catch(err => {
                            vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                vm.showLoading.close();
                            });
                        });
                    }else{ // 修改保存     
                        data.id = vm.updateId;
                        updateLivelink(data).then(res => {
                            if(res.data){
                                vm.$message({ showClose: true, message: '修改成功!', type: 'success' });
                                vm.getCurLinklist();//刷新链接列表
                                vm.dialogVisible = false;   
                            }else{
                                vm.$message({ showClose: true, message: '修改失败！', type: 'error' });
                            }
                            vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                vm.showLoading.close();
                            });
                        }).catch(err => {
                            vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                                vm.showLoading.close();
                            });
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        //重置
        resetForm(){
            let vm = this;
            // vm.$refs[form].resetFields();
            // vm.form.linkname = '';
            // vm.$refs['form'].clearValidate('bookname');
            vm.$refs['form'].clearValidate('openuri');
            vm.form.openuri = '';
            vm.form.openstate = 0;
        },
        //设置链接开关
        switchChange(data){
            let vm = this, params = {};
            // data.openstate == 0 ? params.openstate = 1 : params.openstate = 0;
            params.openstate = data.openstate;
            params.webinarId = data.webinarId;
            params.bookname = data.bookname;
            params.bookurl = data.bookurl;
            params.openuri = data.openuri;
            params.id = data.id;                 
            vm.showLoading = Loading.service({
                target: 'body',
                spinner: 'el-icon-loading',
                text: '加载中...',
                background: 'rgba(255, 255, 255, 0.5)'
            });
            updateLivelink(params).then(res => {
                if(res.data){
                    vm.$message({ showClose: true, message: '修改成功!', type: 'success' });
                    vm.getCurLinklist();
                }else{
                    vm.$message({ showClose: true, message: '修改失败！', type: 'error' });
                }
                vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    vm.showLoading.close();
                });
            }).catch(err => {
                vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    vm.showLoading.close();
                });
            });            
        },
        //添加链接
        addSetLink(){
            let vm = this;
            vm.dialogVisible = true;
            // vm.$refs['form'].resetFields();
            vm.updateId = '';
            vm.form.webinarId = vm.webinarId;
            vm.form.bookname = '';
            vm.form.bookurl = '';
            vm.form.openuri = '';
            vm.form.openstate = 0;
        },
        //获取当前议程直播的链接列表
        getCurLinklist(){
            let vm = this;            
            vm.showLoading = Loading.service({
                target: 'body',
                spinner: 'el-icon-loading',
                text: '加载中...',
                background: 'rgba(255, 255, 255, 0.5)'
            });
            getLivelink({webinarId: vm.webinarId}).then(res => {
                if(res.status){
                    vm.linkData = res.data;
                }
                vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    vm.showLoading.close();
                });
            }).catch(err => {                
                vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    vm.showLoading.close();
                });
            })
        },
        // 获取当天议程列表
        getLiveList(cur){
            let vm = this;
            if(vm.value){
                vm.curIndex = cur;                            
                vm.showLoading = Loading.service({
                    target: 'body',
                    spinner: 'el-icon-loading',
                    text: '加载中...',
                    background: 'rgba(255, 255, 255, 0.5)'
                });
                activitylistSomeDay({
                    date: vm.value,
                    isRight: 1
                }).then(res => {
                    if(res.status && res.data.groupList.length > 0){
                        let index = 0;
                        res.data.groupList.forEach((ele, i) => {
                            if(ele.title == vm.value){
                                index = i;
                            }
                        });
                        vm.listData = res.data.groupList[index].child;
                        vm.$nextTick(() => {
                            vm.curData = vm.listData[0];
                            vm.webinarId = vm.listData[cur].webinarId;
                            vm.getCurLinklist();
                        });
                    }
                    vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                        vm.showLoading.close();
                    });
                }).catch(err => {
                    vm.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                        vm.showLoading.close();
                    });
                })
            }
        }
    }
}
</script>

<style scoped>
    ul, li {
        list-style: none;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .clearfix:after{
        display: block;
        content:'';
        height:0;
        clear: both;
        overflow: hidden;
    }
    .search-date{
        margin-top:30px;
    }
    .list_wrap{
        position: relative;
        padding-right:60%;
        width: 40%;
        margin-top:30px;
    }
    /* .list_wrap>ul{
        width: 40%;
    } */
    .content{
        width:60%;
        height: 100%;
        position: absolute;
        top:0px;
        right:0px;
    }
    .content .wrap{
        border:1px solid #ddd;
        margin:0px 0px 0px 20px;
        /* padding: 20px 15px; */
        height: 100%;
        background-color:#fafafa;
    }
    .wrap .title{
        font-size:18px;
        margin:30px;
    }
    .list_wrap>ul>li{        
        border:1px solid #efefef;
        padding:8px 12px 8px 105px;
        border-radius:4px;
        margin: 15px 0;
        font-size:14px;
        position: relative;
        cursor: pointer;
    }
    .list_wrap>ul>li:hover{
        color:rgb(238, 102, 102);
    }
    .list_wrap>ul>li>span.txt{
        position: absolute;
        top:8px;
        left:10px;
    }
    .list_wrap>ul>li.cur{
        border:1px solid rgb(238, 102, 102);
        color:rgb(238, 102, 102);
        background-color: #ffffcc;
    }
    .setlink{
        color:rgb(238, 102, 102);
        cursor: pointer;
    }
    .line{
        margin-bottom: 15px;
        margin-left:30px;
    }
    .line .txt{
        display: inline-block;
        width:120px;
        text-align: right;
        margin-right: 10px;
    }
    .box ul li{
        /* width:400px; */
        margin:10px 0;
    }
    .box ul li .el-switch{
        margin: 3px 10px 0px 10px;
    }
    .linkipt>>>.el-input.is-disabled .el-input__inner{
        color:#333;
        cursor: text;
    }
    .linkipt .name{
        width:130px;
        margin-right:10px;
    }
    .linkipt .url{
        width:300px;
    }
    .linkipt>>>.el-input--suffix .el-input__inner{
        padding: 0px 5px;
    }
</style>


// WEBPACK FOOTER //
// src/views/SysManager/setLiveLink/App.vue